//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/Builder.js";
let d=[[[0,"InputFileName",1,0],[0,"UpdateChecksum",1,0],[0,"UpdateGuid",1,0]],[[[],"CreateSubtypeAuthorValidValuesBuilder",{R_:{validValuesBuilder:"Join.SubtypeAuthorValidValuesBuilder"}},0,0],[[],"CreateSubtypeAuthorAddNewAttributesBuilder",{R_:{addNewAttributesBuilder:"Join.SubtypeAuthorAddNewAttributesBuilder"}},0,0]],[]];
SPLM.Join.SubtypeAuthorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.SubtypeAuthorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.SubtypeAuthorBuilder.OutputType = Object.freeze({
    "IntermediateFile" : "IntermediateFile"});

export default SPLM;